import React from 'react';
import { Stack, Box, Typography, Tooltip } from '@mui/material';

import { Content } from './styles';
import { getCareCenterStatusTextAndIcon } from './utils';

const Card = ({ name, city, status, error, ...rest }) => {
  const {
    status: statusText,
    color: statusColor,
    icon: statusIcon,
  } = getCareCenterStatusTextAndIcon(status);
  return (
    <Content
      {...rest}>
      <Stack
        flex={1}>
        <Typography
          variant='pb1'
          color='primary.gray8'
          sx={{ fontWeight: 700 }}>
          {name}
        </Typography>
        <Typography
          variant='pl1' color='primary.grey5'>
          {city}
        </Typography>
        <Box
          mt={3} display='flex' alignItems='center'>
          <Typography
            variant='pl4' color='primary.grey5'>
            Status:
          </Typography>
          <Tooltip
            title={error} placement='top'>
            <Box
              display='flex' alignItems='center'>
              <Typography
                fontWeight='600'
                variant='pl3'
                color={statusColor}
                sx={{ ml: 1 }}>
                {statusText}
              </Typography>
              {statusIcon}
            </Box>
          </Tooltip>
        </Box>
      </Stack>
    </Content>
  );
};

export default Card;
